import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/error_hover.svg'


const _withScopeId = n => (_pushScopeId("data-v-7daa852f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component popup" }
const _hoisted_2 = { class: "popup_box contents__box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-box" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "중복 업로드된 파일이 발견되었습니다."),
  /*#__PURE__*/_createElementVNode("h3", null, "아래 파일은 이미 업로드된 상태이므로 제외됩니다.")
], -1))
const _hoisted_5 = { class: "file-list-box my-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.duplicationFileList, (list) => {
            return (_openBlock(), _createElementBlock("div", {
              key: list,
              class: "file_name_box"
            }, [
              _createElementVNode("h3", null, _toDisplayString(list.origin_filename), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("button", {
          class: "button__blue btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleConfirmClick()))
        }, "확인")
      ])
    ])
  ]))
}